import { render } from "./AdminSystemParameters.vue?vue&type=template&id=4971878f&scoped=true&ts=true"
import script from "./AdminSystemParameters.ts?vue&type=script&lang=ts"
export * from "./AdminSystemParameters.ts?vue&type=script&lang=ts"

import "./AdminSystemParameters.vue?vue&type=style&index=0&id=4971878f&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalRO\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4971878f"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
